import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'textFormat',
    standalone: false
})
export class TextFormatPipe implements PipeTransform {

  transform(value: string): string {
    if (!value) return '';

    return value
      .replaceAll(/([a-z])([A-Z])/g, '$1 $2')
      .replaceAll(/[_-]+/g, ' ')
      .replaceAll(/\s+/g, ' ')
      .trim()
      .toLowerCase()
      .replaceAll(/\b\w/g, char => char.toUpperCase());
  }

}
